import { useSession } from "../store/helperHooks";

export const useRecognizedHoliday = () => {
  const { recognizedHoliday } = useSession();

  return recognizedHoliday;
};
